import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Brand, CTA, BrandStoryBanner } from './components'
import {Blog, Features, Header,
  WhatSnagEasy, HIservices, Youtube, Processflow,
  Defects, Testimonials, Faq, Inspectionprojects, InspectionSections, Locations} from './containers'
import { headerData } from './data/headerData'
import './App.css'

const PAGE_URL = 'https://www.snageasy.in/';
const OG_IMAGE = 'https://cdn.snageasy.in/app-img/webp/home_inspection_service_in_mumbai.webp';

const homepageFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is home inspection?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Home inspection is a technical examination of each component of a home using advanced tools and modern technology by professional home inspectors. It covers civil, electrical, plumbing, dampness, and RERA carpet area verification."
      }
    },
    {
      "@type": "Question",
      "name": "What are the benefits of home inspection?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Home inspection helps identify defects in your new home which you can get rectified from the developer before taking possession. Such defects become expensive if not uncovered on time, saving homebuyers significant repair costs."
      }
    },
    {
      "@type": "Question",
      "name": "How much time is required for home inspection?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "On average 3 to 4 hours are sufficient to carry out a complete home inspection for a 2BHK. Larger properties or those requiring thermal scanning may take slightly longer."
      }
    },
    {
      "@type": "Question",
      "name": "What does a home inspection cover?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Home inspection covers leakage and dampness identification, electrical inspection, plumbing inspection, door and window inspection, walls and ceiling inspection, floor and dado tile inspection, RERA carpet area verification, and more — totalling 200+ checkpoints."
      }
    },
    {
      "@type": "Question",
      "name": "When is the home inspection report delivered?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The home inspection report PDF is delivered within 24 hours after completion of the on-site inspection, via email and the SnagEasy app."
      }
    }
  ]
};

const Home = () => {

  const titles = ['Cost-Effective, Professional Home Inspection Services at Your Doorstep', 'Your Home Health, Our Top Priority. Opt for a Home Inspection.', 'Ensuring Safe and Sound Investments. Discover the Benefits of Home Inspections.', 'Peace of Mind, One Inspection at a Time. Learn More About Home Inspections Today.', 'Quality Home Inspections for Quality Living. Invest 0.1% More to Extend the Life of Your Home.'];
  const definations = ['A full home inspection.. is a technical examination of each component of home with the help of advance tools and modern technology by professional home inspectors.',
  'Home inspection involves a thorough examination of a new or renatl home physical state by qualified inspectors, identifying defects and potential problems to help buyers make informed decisions.',
  'When anyone is buying a house or property, it is important that they must opt for home inspection service to do an end to end inspection so that they know that they are buying the right property. Our team of inspection experts help you to identify all defects in newly constructed or rental property so that you can get it resolved before moving into it.',
  'Taking possession of new home from builder? Get it inspected by our professional home inspectors to identify defects and get it rectified from builder before moving in.'];

  return (
    <div>
      <Helmet>
        <title>Professional Home Inspection Services in Mumbai, Pune, Bangalore, Chennai & Lonavala | SnagEasy</title>
        <meta
          name="description"
          content="SnagEasy provides expert pre-possession home inspection across Mumbai, Pune, Bangalore, Chennai & Lonavala. 200+ checkpoints, thermal imaging, RERA-compliant snag reports, 24hr delivery. 1300+ homes inspected."
        />
        <link rel="canonical" href={PAGE_URL} />
        <meta property="og:title" content="Professional Home Inspection Services | SnagEasy" />
        <meta
          property="og:description"
          content="Expert home inspection in Mumbai, Pune, Bangalore, Chennai & Lonavala. 1300+ homes inspected. Thermal imaging, RERA-compliant snag reports within 24 hours. Book your inspection today."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={PAGE_URL} />
        <meta property="og:image" content={OG_IMAGE} />
        <meta property="og:site_name" content="SnagEasy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Professional Home Inspection Services | SnagEasy" />
        <meta
          name="twitter:description"
          content="200+ checkpoint pre-possession home inspections in Mumbai, Pune, Bangalore, Chennai & Lonavala. RERA-compliant reports within 24 hours."
        />
        <meta name="twitter:image" content={OG_IMAGE} />
        <script type="application/ld+json">{JSON.stringify(homepageFaqSchema)}</script>
      </Helmet>
      <Header
        titleList={titles}
        definationList={definations}
        img={headerData.homeHeroImageUrl}
      />
      {/* Same hero artwork as Header — visible only ≤768px, above step-by-step guide */}
      <div className="home-hero-mobile-strip" aria-hidden="true">
        <div className="home-hero-mobile-strip-inner">
          <img
            src={headerData.homeHeroImageUrl}
            alt=""
            className="home-hero-mobile-strip-img"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
      <Processflow />
      
      <HIservices/>
      <Brand />
      <Locations />
      <Features />
      <Defects />
      <InspectionSections />
      {/* <Topservices/> */}
      <WhatSnagEasy />
      <Youtube />
      <Testimonials />
      <Inspectionprojects />
      <Faq />
      <CTA />
      <BrandStoryBanner />
      <Blog />
     
    </div>    
  );
};

export default Home;
